// extracted by mini-css-extract-plugin
module.exports = {"selectionCheckBox":"ByUser_selectionCheckBox__Sia0B"};